import s from './info-referral-card.module.scss'
import { IconExternalLink } from '@tabler/icons-react'


export const InfoReferralCard = ({label, description, openModal}) => {

    return (
        <div className={s.container} onClick={() => openModal()} role="button" tabIndex={0}>
            <div className={s.textWrapper}>
                <h1>{label}</h1>
                <p>{description}</p>
            </div>
            <span className={s.icon}>
                <IconExternalLink size={24} strokeWidth={1} color='#F87728'/>
            </span>
        </div>
    )
}